// extracted by mini-css-extract-plugin
module.exports = {"root":"clients-module--root--3MyAD","logo_wrapper":"clients-module--logo_wrapper--3PsSE","logo":"clients-module--logo--NmuAk","more":"clients-module--more--36ZPO"};